<template>
  <div class="edi_setting">
    <iframe
      :src="url"
      seamless
      style="border: 0"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: "SchedulesJwnetMaintenancesIndex",
  data() {
    return {
      url: process.env.VUE_APP_SCHEDULES_JWNET_MAINTENANCES_URL,
    };
  },
};
</script>

<style scoped lang="scss">
.edi_setting{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.edi_setting iframe{
  flex-grow: 1;
  padding-bottom: 30px;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
}
</style>
